'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookGlobalSettings = require('@narvar/nth-hook-global-settings');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PrefetchData = ({
  children
}) => {
  const {
    loading: settingsLoading
  } = nthHookSettings.useSettingsX();
  const {
    loading: globalSettingsLoading
  } = nthHookGlobalSettings.useGlobalSettingsX();
  const {
    loading: translationsLoading
  } = nthHookTranslations.useTranslationsX();
  if (settingsLoading || globalSettingsLoading || translationsLoading) return null;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children);
};
var PrefetchData$1 = nthHookSettings.withSettingsProvider(nthHookGlobalSettings.withGlobalSettingsProvider(nthHookTranslations.withTranslationsProvider(PrefetchData, {
  translationKeys: ['trackPageTitle', 'trackingStatus']
}), {
  globalSettingsRequested: `
        giftSharingEnabled
        internationalDateFormatting
        retailerLevelOptInEnabled
        hipaaCompliant
        retailerName
        orderLevelOptInEnabled
        smsDefaultCountry
        trackPageAssistPortalLinkEnabled
      `
}), {
  settingsRequested: `
      assets
      broadcastBanner {
        uid
        startDateUtc
        endDateUtc
        title
        body
        linkText
        linkUrl
        dismissible
      }
      eddPanel {
        expandEventHistoryByDefault
      }
      feedback {
        enableInitialCollapse
        enableStarRatingText
        customerSupportLink
        enablePanelHeader
        commentOptional
      }
      globalScopeCSS
      helpPill {
        helpPageHref
        showIcon
        showText
        displayIconLast
        customComponentSettingsId
      }
      itemsInThisShipment {
        showCarouselDots
        imageUrl
        url
      }
      moreInformation {
        showBlockHeader
        showLink
        link
      }
      narvarFooter {
        logoHref
        hideLogo
        hideInEmbed
        hidePrivacyLink
      }
      notificationCenter {
        channel
        continueShoppingUrl
        enableEmailDisclaimerText
        toggleDisclaimerText
        marketingOptInEnabled
        marketingOptInPrivacyLink
        marketingOptInTermsLink
      }
      pickupLocation {
        moreInfoLink
        showMoreInfoLink
        showMap
      }
      shipments {
        imageUrl
        url
      }
      trackHeader {
        html
        querySelectors
        sticky
      }
      trackPageLayout
    `
});

exports["default"] = PrefetchData$1;
